import {useMemo} from 'react'
import {
  TextField,
  Select,
  MenuItem,
  Box,
  IconButton,
} from '@mui/material' 
import ClearIcon from '@mui/icons-material/Clear'
import {formatUnderFromCamel} from '@utils/formatText'
import moment from 'moment'
import DateForm from '@components/DateForm'

const DynamicSearch = ({
  list, 
  onChangeSearchKeyword, 
  onChangeSearchType, 
  searchType, 
  searchKeyword
}) => {

  const onDebounceChangeSearchKeyword = () => {
    let timer = null
    return (value) => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      timer = setTimeout(() => {
        onChangeSearchKeyword(value)
      }, 300)
    }
  }

  const onClearKeywordInput = () => {
    const keywordInput = document.querySelector('.keyword input')
    if (keywordInput) keywordInput.value = ''
    onChangeSearchKeyword('')
  }

  const isDateForm = useMemo(() => {
    return searchType.indexOf('DATE') !== -1 || searchType.indexOf('BIRTH') !== -1;
  }, [searchType])

  const selectList = list
    .filter(data => data.search)
    .map(data => {
      const cloneData = Object.assign({}, data)
      cloneData.key = formatUnderFromCamel({text: cloneData.key})
      return cloneData
    })
  const debounceChangeSearchKeyword = onDebounceChangeSearchKeyword()

  return (
    <Box sx={{float: 'right', mt: -6}}>
      <Select
        value={searchType}
        onChange={(e) => onChangeSearchType(e.target.value)}
        size="small"
        sx={{backgroundColor: '#fcfcfc'}}
      >
        {
          selectList.map(({key, name}, index) => {
            return <MenuItem key={index} value={key}>{name}</MenuItem>
          })
        }
      </Select>
      {
        !isDateForm && <TextField
          defaultValue={searchKeyword}
          size="small"
          placeholder={`검색`}
          className="keyword"
          onChange={(e) => debounceChangeSearchKeyword(e.target.value)}
        />
      }
      {
        isDateForm && <DateForm 
          className="keyword"
          value={searchKeyword ? new Date(searchKeyword) : null}
          handleChangeData={(_, newValue) => debounceChangeSearchKeyword(moment(newValue).format('YYYY-MM-DD'))}
        />
      }
      {
        searchKeyword && <IconButton onClick={onClearKeywordInput} sx={{position: 'absolute', right: isDateForm ? 50 : 20}}>
          <ClearIcon sx={{fontSize: 18}} />
        </IconButton>
      }
    </Box>
  )
}

export default DynamicSearch